import WaitingButton from './WaitingButton';

export default WaitingButton;
